import React from "react"
import { Link } from "gatsby"

//MUI v5完了
//MUI v5
import { ListItem, ListItemText, List, Divider, Collapse, Box, Toolbar, Drawer, Tooltip, ListItemIcon } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery';

//json
import categories from './categories.json'
import category_count from './category_count.json'

//コンポーネント
import SpacingBox from './spacing_box.js'
import ClientOnly from './ClientOnly'

//検索窓遅延読み込みはビルドの実行時エラーを吐き始めたので退避
// const Search = React.lazy(() => import('./GoogleCustomSearch'))
import Search from './GoogleCustomSearch'

//ドロワ
const DrawerComponent = (({ setMobileOpen, mobileOpen, selected_category }) => {

    const drawerWidth = 300;
    const theme = useTheme();

    //index経由の場合はselected_categoryはundefinedで来るので初期化する(初期化しないとエラー)
    if (!selected_category) {
        selected_category = {
            parent_category_id: "",
            child_category_id: ""
        }
    }
    //「全記事」ボタンから入った時：子idを親idと同じにすることで処理
    if (selected_category.child_category_id === null) {
        selected_category.child_category_id = selected_category.parent_category_id
    }

    const [drawerOpen, setDrawerOpen] = React.useState({ [selected_category.parent_category_id]: true })
    const drawerOpenClick = (keyName) => {
        setDrawerOpen(
            { ...drawerOpen, [keyName]: !drawerOpen[keyName] }
        )
    }

    //ドロワを画面サイズでテンポラリとプレシステントで分ける奴。
    const [drawerVariant, setDrawerVariant] = React.useState("persistent")
    const isMdDown = useMediaQuery((theme) =>
        theme.breakpoints.down('md'), { noSsr: true }
    );
    const toggleDrawer = () => {
        setMobileOpen(!mobileOpen)
    }
    React.useEffect(() => {
        setDrawerVariant(isMdDown ? "temporary" : "persistent")
    }, [mobileOpen, isMdDown])
    //ドロワのテンポラリ状態分けここまで

    //カテゴリ選択からページ遷移した時対象カテゴリのcollapseをオープンしておく
    React.useEffect(() => {
        if (Object.keys(drawerOpen).length === 0) {
            setDrawerOpen(
                { ...drawerOpen, [selected_category.parent_category_id]: true }
            )
        }
    }, [drawerOpen, selected_category.parent_category_id])

    //画面遷移するときにモバイルの場合は一旦閉じる
    const drawerCheck = () => {
        if (isMdDown) setMobileOpen(false)
    }

    //画面がでかいときに隠すメニュー
    const downMdOnlyMenuStyle = {
        display: "none",
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
        },
    }

    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 1,
                '& .MuiDrawer-paper': { width: drawerWidth, },
                //ドロワの場合マウスオーバーしたときだけスクロールバーを表示
                '& ::-webkit-scrollbar': {
                    display: "none"
                },
                '& :hover': {
                    '::-webkit-scrollbar': {
                        display: "inline"
                    }
                },
            }}
            variant={drawerVariant}
            onClose={toggleDrawer}
            open={mobileOpen}
        >
            <Toolbar />
            <Box sx={{ overflow: 'auto', }}>
                <List
                    sx={{
                        //選択されているカテゴリの色
                        //アンパサンド2回にしないと機能しない
                        //https://stackoverflow.com/questions/61486061/how-to-set-selected-and-hover-color-of-listitem-in-mui
                        "&& .Mui-selected": {
                            backgroundColor: theme.palette.secondary.mainDark,
                        },
                        '& .MuiListItem-button:hover': {
                            backgroundColor: theme.palette.divider
                        }
                    }}
                >

                    {/* 折りたたみカテゴリ */}
                    {categories.map((category) => {
                        if (category.category_id !== "999") { //未分類だけ表示しない
                            return (
                                <div key={category.category_name}>
                                    <ListItem button onClick={() => drawerOpenClick(category.category_id)}
                                        sx={{
                                            backgroundColor: drawerOpen[category.category_id] ? theme.palette.primary.light : null
                                        }}>
                                        <ListItemText
                                            //大カテゴリ
                                            primary={category.category_name}
                                        />
                                        {drawerOpen[category.category_id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItem>
                                    <Collapse in={drawerOpen[category.category_id]} timeout="auto" unmountOnExit
                                        sx={{
                                            borderLeft: "4px solid",
                                            borderColor: theme.palette.primary.light,
                                        }} >
                                        <List component="div" disablePadding dense={false}>

                                            {/* 全記事ボタン */}
                                            <ListItem button sx={{ paddingLeft: theme.spacing(4), }}
                                                onClick={drawerCheck}
                                                component={Link} to={"/category/" + category.category_id}
                                                selected={selected_category.child_category_id === category.category_id} >
                                                {selected_category.child_category_id === category.category_id ? (
                                                    <ListItemIcon>
                                                        <DoubleArrowIcon fontSize="small" sx={{ color: "white" }} />
                                                    </ListItemIcon>) : null
                                                }
                                                <ListItemText primary={category.category_name + "(全記事)"} />
                                            </ListItem>


                                            {category.sub_category?.map((sub_category) =>
                                                <ListItem button sx={{ paddingLeft: theme.spacing(4), }} selected={selected_category.child_category_id === sub_category.sub_category_id} component={Link} to={"/category/" + sub_category.sub_category_id} key={sub_category.sub_category_id}
                                                    disabled={!category_count[sub_category.sub_category_id]}
                                                    onClick={drawerCheck}
                                                >
                                                    {selected_category.child_category_id === sub_category.sub_category_id ? (
                                                        <ListItemIcon>
                                                            <DoubleArrowIcon fontSize="small" sx={{ color: "white" }} />
                                                        </ListItemIcon>) : null
                                                    }
                                                    {/* 下は子カテゴリ名＋記事数 */}
                                                    <ListItemText
                                                        primary={
                                                            sub_category.sub_category_name + " (" + (category_count[sub_category.sub_category_id] || "0") + ")"
                                                        }
                                                    />
                                                </ListItem>
                                            )}

                                        </List>
                                    </Collapse>
                                </div>
                            )
                        } else { return null }
                    }
                    )}
                    {/* 折りたたみカテゴリ */}

                    <Divider />
                    <Box marginTop={1}>
                        <ListItem button component={Link} to={"/tags-all"} dense onClick={drawerCheck}
                            sx={downMdOnlyMenuStyle}
                        >
                            <ListItemText primary="タグ一覧" />
                        </ListItem>
                        <ListItem button component={Link} to={"/tags-finder"} dense onClick={drawerCheck}
                            sx={downMdOnlyMenuStyle}
                        >
                            <ListItemText primary="タグ絞り込み検索" />
                        </ListItem>
                        <ListItem button component={Link} to={"/site-description"} dense onClick={drawerCheck}
                            sx={downMdOnlyMenuStyle}
                        >
                            <ListItemText primary="謎の技術研究部とは" />
                        </ListItem>

                        {/* <ListItem button component={Link} to={"/category/999"} dense>
                            <ListItemText primary="未分類" />
                        </ListItem> */}
                        <ListItem button component={Link} to={"/policy"} dense onClick={drawerCheck}>
                            <ListItemText primary="プライバシーポリシー" />
                        </ListItem>
                        <ListItem button component={Link} to={"/sub_index/1"} dense onClick={drawerCheck}>
                            <ListItemText primary="ホーム(自動スクロールなし)" />
                        </ListItem>
                        <ListItem button component={Link} to={"/contact"} dense onClick={drawerCheck}>
                            <ListItemText primary="ご意見、お問い合わせ" />
                        </ListItem>

                        {/* スマホ用検索インプット 遅延読み込みに変更 */}
                        <Box sx={{
                            [theme.breakpoints.up('lg')]: {
                                display: "none",
                            }
                        }}>
                            <Tooltip title="サイト内検索 Powered by Google" placement="top">
                                <ListItem >
                                    {/* suspenseがエラーを吐いているようなので退避 */}
                                    {/* <React.Suspense fallback={<Box>loading...</Box>}> */}
                                        <ClientOnly>
                                            <Search id="ac14fce807686bac9" />
                                        </ClientOnly>
                                    {/* </React.Suspense> */}
                                </ListItem>
                            </Tooltip>
                        </Box>
                        {/* スマホ用 検索ここまで */}

                    </Box>
                </List>
                {/* 下部広告が表示されているときに隠れてしまうのでページを引き伸ばす */}
                <SpacingBox />
            </Box >
        </Drawer >
    )
}
);

export default DrawerComponent

//gatsbyPathをつかった例
//{~~~}.jsのslugが変換されるため(例：ZBrush > z-brush)ハードコードではアクセスできない
//そこでgatsbyPathからパスを抽出して使用する

// export const query = graphql`
//     query DrawerQuery {
//         allMarkdownRemark {
//         edges {
//             node {
//             fields {
//                 parent_category
//             }
//             category_path: gatsbyPath(filePath: "/category/{MarkdownRemark.fields__parent_category}")
//             }
//         }
//         }
//     }
// `